import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './i18n';
import './index.css';
import App from './App';
import { store } from './Redux/store';
import { registerServiceWorker } from './lib/serviceWorker';

// The app shell is cached so a returning guest on venue Wi-Fi sees the
// app rather than a browser error page. Registered before render: it takes
// effect on the next navigation and must not delay this one.
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
